<template>
	<div class="pano-viewer-wrapper">
		<div
			class="close-button-wrapper"
			@click="setIsPanoViewerVisible(false)"
		>
			<svg
				width="14"
				height="14"
				viewBox="0 0 14 14"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M12.8966 1L1 12.7931"
					stroke="white"
					stroke-width="0.835088"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M13.0001 13L1.20703 1.10345"
					stroke="white"
					stroke-width="0.835088"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
			</svg>
		</div>
		<div id="PanoCanvas"></div>
		<PoweredByFoyrLoader
			v-if="showPoweredByFoyrLoader"
		></PoweredByFoyrLoader>
		<Three60InteractionPopup
			v-if="show360InteractionOverlay"
			@click.native="show360InteractionOverlay = false"
		></Three60InteractionPopup>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import PanoViewerMixin from "../mixins/PanoViewerMixin";
import PoweredByFoyrLoader from "./poweredByFoyrLoader.vue";
import Three60InteractionPopup from "@/components/three60InteractionPopup.vue";

export default {
	name: "PanoViewer",
	mixins: [PanoViewerMixin],
	components: {
		PoweredByFoyrLoader,
		Three60InteractionPopup,
	},
	props: {},
	data() {
		return {
			camera: undefined,
			controls: undefined,
			renderer: undefined,
			scene: undefined,
			materials: [],
		};
	},
	computed: {
		...mapGetters(["isPanoViewerVisible"]),
	},
	created() {},
	mounted() {
		this.init();
		this.animate();
	},
	watch: {
		isPanoViewerVisible(nv) {
			if (nv && this.cuboids.length) {
				this.updateTexture(this.cuboids);
			}
		},
	},
	methods: {
		...mapMutations(["setIsPanoViewerVisible"]),
	},
	destroyed() {},
};
</script>

<style lang="scss" scoped>
.pano-viewer-wrapper {
	position: fixed;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	background-color: color(secondary-white);

	.close-button-wrapper {
		cursor: pointer;
		position: absolute;
		right: 2rem;
		top: 2rem;
		background-color: color(secondary-white);

		border-radius: 50%;
		height: 3rem;
		width: 3rem;

		display: flex;
		align-items: center;
		justify-content: center;

		svg {
			path {
				stroke: color(secondary-black);
			}
		}
	}
}
</style>
